var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback"},[_vm._v("登录中，请稍后...")])
}
var staticRenderFns = []

export { render, staticRenderFns }